<template>
    <VJoyInput
        v-model.trim="modelValue"
        name="email"
        type="email"
        :placeholder="$t('registration.password.renewal.input.email.placeholder')"
        :autofocus="autofocus"
        :invalid="invalid"
    />
</template>

<script setup lang="ts">
    import {watch} from 'vue';
    import {email} from '@regle/rules';
    import debounce from 'lodash-es/debounce';
    import {useRoute} from 'nuxt/app';
    import {VJoyInput} from '@maltjoy/core-vue';
    import {useSigninStore} from '~/store/signin.store';

    defineProps<{
        invalid: boolean;
        autofocus?: boolean;
    }>();

    const modelValue = defineModel<string>({default: ''});

    const signinInStore = useSigninStore();
    const route = useRoute();

    const getSigninMethodsRestrictionsDebounced = debounce(() => {
        if (!email.exec(modelValue.value)) {
            signinInStore.resetSigninMethod();
            return;
        }
        signinInStore.getSigninMethodsRestrictions(route.query.redirect as string);
    }, 250);

    watch(modelValue, () => {
        getSigninMethodsRestrictionsDebounced();
    });
</script>
